"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const keautils_1 = require("keautils");
/**Convierte un valor o un arreglo de valores de un selector a un arreglo de un selector */
function valueToArray(value) {
    if (keautils_1.isArray(value)) {
        return value;
    }
    else {
        return value == null ? [] : [value];
    }
}
/**Devuelve una función que carga los elementos de una lista o selector basado en un resource, es decir, en una función que obtiene un conjunto de elementos filtrados y en otra que obtiene un elemento dado su id.
 * Sirve para mostrar en el listado los elementos filtrados pero también los elementos seleccionados, incluso si los seleccionados no se encuentran en el filtro
 * La función query y get no son memoizadas por esta función.
 * @param query Función que obtiene un conjunto de elementos dado el filtro
 * @param get Función que obtiene un elemento dado su valor
 * @param map Función que obtiene un @see SelectorElement dado un @see Item
 * @param includeValues Indica si para cierto filtro se deben de incluir en la lista los valores seleccionados. Esto va a implicar que se realizen los GET de los elementos seleccionados que no se encuentran en la lista
 */
function loadItemsFuncFromResource(query, get, mapValue, includeValues) {
    let lastGetManyValues, lastGetManyResult;
    /**Obtiene un conjunto de items dados sus IDs, esta función es memoizada */
    function getMany(values) {
        if (keautils_1.shallowEquals(values, lastGetManyValues)) {
            return lastGetManyResult;
        }
        let result = [];
        for (const val of values) {
            const getResult = keautils_1.toObservable(get(val));
            result.push(getResult);
        }
        lastGetManyValues = values;
        //NOTA: rxjs tiene un bug que hace que combineLatest no termine cuando la colección esta vacia
        //https://github.com/ReactiveX/rxjs/issues/3189
        if (result.length == 0) {
            const ret = rxjs_1.Observable.from([[]]);
            lastGetManyResult = ret;
        }
        else {
            lastGetManyResult = rxjs_1.Observable.combineLatest(...result);
        }
        return lastGetManyResult;
    }
    return function (filtro, value) {
        //Obtenemos todos los valores del query
        const queryResult = keautils_1.toObservable(query(filtro));
        queryResult.do(x => { }, error => {
            //Al tener un error, limpiamos el cache
            query.clear();
        });
        const queryItems = queryResult;
        const queryValues = queryItems.map(x => x.map(mapValue));
        if (!includeValues(filtro)) {
            return queryItems;
        }
        //Devolvemos el queryResult, y todos los elementos en los valores seleccionados que no se encuentren en el query result.
        //Obtener los valores que están afuera del query
        const valueArray = valueToArray(value);
        const valoresFueraQuery = queryValues.map(values => {
            return valueArray.filter(x => !keautils_1.contains(values, x));
        });
        //Hacemos todas las peticiones de los valores que faltan:
        const getResults = valoresFueraQuery.map(x => {
            return getMany(x);
        }).switch(); //(await getMany(valoresFueraQuery as any[])).map(map);
        //Si no tiene filtro, mostramos lo resultados seleccionados primero
        const ret = rxjs_1.Observable.combineLatest(getResults, queryItems, (a, b) => {
            return [...a, ...b];
        });
        return ret;
    };
}
exports.loadItemsFuncFromResource = loadItemsFuncFromResource;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/selector/loaditemsfunctions.js
// module id = 512
// module chunks = 0